import { SolAuthority } from '@sol/components';

export class AsmLicensingAuthority {
  public static readonly VIEW_APP: SolAuthority = 'VIEW_LICENSING_APP';
  public static readonly VIEW: SolAuthority = 'VIEW_LICENSING';
  public static readonly MANAGE_CUSTOMERS: SolAuthority = 'MANAGE_LICENSING_CUSTOMERS';
  public static readonly MANAGE_CATALOG: SolAuthority = 'MANAGE_LICENSING_CATALOG';
}
